export const getCloudflareJsonData = (text) => {
    var data = text.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
    data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
    return JSON.parse(data)
}